import { Box } from "@givenwell/components";
import { createFileRoute } from "@tanstack/react-router";
import { boolean, fallback, object, optional, string } from "valibot";
import { CoverageMap } from "./CoverageMap";

export const Route = createFileRoute("/dashboard/coverage")({
  validateSearch: object({
    view: fallback(optional(string()), undefined),
    standard: fallback(optional(string()), undefined),
    choropleth: fallback(optional(boolean()), undefined),
  }),
  component: Page,
});

function Page() {
  const search = Route.useSearch();
  const { view, standard, choropleth } = search;
  const navigate = Route.useNavigate();
  return (
    <Box
      css={{
        position: "relative",
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
      }}
    >
      <CoverageMap
        regionCode={view}
        onRegionCodeChange={v =>
          navigate({
            to: ".",
            search: {
              ...search,
              view: v,
            },
            replace: true,
          })
        }
        initialStandard={standard}
        onStandardChange={s =>
          navigate({
            to: ".",
            search: {
              ...search,
              standard: s,
            },
            replace: true,
          })
        }
        choropleth={choropleth || false}
        onChoroplethChange={c =>
          navigate({
            to: ".",
            search: {
              ...search,
              choropleth: c,
            },
            replace: true,
          })
        }
      />
    </Box>
  );
}
